<script>
import { biometricService } from '@/src/services/safehaven/BiometricService'
import { authComputed } from '@state/helpers'
import { connectDeviceService } from '@services/safehaven/ConnectDeviceService'
import * as _ from 'lodash'

export default {
  emits: ['settings-saved'],
  data() {
    return {
      tab: '',
      settingDialog: false,
      strict: true,
      vitals: [],
      defaultVitals: null,
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getSettings()
  },
  methods: {
    getSettings() {
      biometricService
        .getVitalStatus(this.currentUser.user.user_id)
        .then((res) => {
          const validicData = JSON.parse(localStorage.getItem('validicData'))
          res.data[0].vitals_status.map((rec) => {
            // eslint-disable-next-line no-unneeded-ternary
            rec.status = rec.status === 'Enabled' ? true : false
            rec.show = false
            validicData.map((card) => {
              if (rec.vital_name === card.title) {
                rec.show = true
              }
            })
          })

          this.vitals = res.data[0]
          this.vitals.vitals_status = this.vitals.vitals_status.filter(
            (item) => item.show
          )
          this.defaultVitals = _.cloneDeep(res.data[0])
          this.$emit('settings-saved', this.vitals)
        })
    },
    saveSettings() {
      const saveData = _.cloneDeep(this.vitals)
      saveData.vitals_status.map((rec) => {
        // eslint-disable-next-line no-unneeded-ternary
        rec.status = rec.status ? 'Enabled' : 'Disabled'
      })
      biometricService.saveVitals(saveData).then((res) => {
        this.getSettings()
        this.settingDialog = false
      })
    },
    async connectDevice() {
      try {
        const getLink = (await connectDeviceService.connectDevice()).data
        if (getLink) {
          window.open(getLink.marketplace_url, '_blank')
        }
      } catch (error) {
        console.warn(error.response)
      }
    },
  },
}
</script>

<template>
  <v-dialog v-model="settingDialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <div :class="$style.buttonWrapper" v-bind="attrs" v-on="on">
        <img
          :src="require('@assets/images/safehaven/settings_icon.png')"
          width="20"
          class="mr-1"
        />
        <!-- <v-btn
          :ripple="false"
          plain
          class="clickable primary--text"
          :class="$style.settingClass"
        >
          Settings
        </v-btn> -->
      </div>
    </template>

    <v-card>
      <v-card-title>
        <div class="pa-3">
          <a :class="$style.connectiontabClass">Connections</a>
        </div>
        <div :class="$style.vl" />
        <div class="pa-3">
          <a :class="$style.widgettabClass">Display Widgets</a>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="settingDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-simple-table dense>
          <template v-slot>
            <thead>
              <tr>
                <th class="text-left"> </th>
                <th class="text-left" :class="$style.showTextClass"> Show </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in vitals.vitals_status" :key="item.vital_name">
                <td
                  :class="
                    item.show ? $style.tabItemClass : $style.tabItemClassDisable
                  "
                  >{{ item.vital_name }}</td
                >
                <td>
                  <v-switch
                    v-model="item.status"
                    color="primary"
                    hide-details
                    :disabled="!item.show"
                  ></v-switch
                ></td>
              </tr>
              <v-divider></v-divider>
            </tbody>
            <v-btn color="primary" class="my-5" rounded @click="saveSettings"
              >Save</v-btn
            >
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';

.buttonWrapper {
  display: flex;
  align-items: center;
  margin-left: 30px;
}
.settingClass {
  font-size: 14px !important;
  text-transform: unset !important;
  border: 0 solid !important;
}
.settingClass:first-child {
  margin-right: 8px;
}

.widgettabClass {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  text-transform: unset !important;
}

.connectiontabClass {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.vl {
  height: 20px;
  border-left: 3px solid rgb(206, 206, 206);
}

.showTextClass {
  font-size: 15px;
  font-weight: 400;
  color: black !important;
}

.tabItemClass {
  font-size: 20px;
  font-weight: 900;
  color: black;
}
.tabItemClassDisable {
  font-size: 20px;
  font-weight: 900;
  color: #c2c3c4;
}

@media screen and (max-width: 479px) {
  .widgettabClass {
    font-size: 12px !important;
  }

  .connectiontabClass {
    font-size: 12px !important;
  }
}
@media screen and (max-width: 460px) {
  .settingClass {
    flex: 1 1 100%;
    margin-right: 0 !important;
    margin-bottom: 20px;
  }
}
</style>
